import React, { useContext, useState } from 'react'
import LoggedInUi from './LoggedInUi'
import Password from '../Components/Shared/Password';
import { makeAuthenticatedPOSTRequest } from '../utils/endPointCalling';
import { useCookies } from 'react-cookie';
import modalContext from '../context/ModalContext';

function Delete() {
    const [password, setPassword] = useState('');
    const [cookie, setCookie] = useCookies(['token']);
    const {load, setLoad} = useContext(modalContext);

    const deleteAccount = async () => {
        if(!password){ 
            alert('Enter Password');
            return;
        }
        const body={password: password};
        const response = await makeAuthenticatedPOSTRequest('/auth/delete/account', body);
        if(response && !response.err){
            setCookie('token', '', {path: '/'});
            setLoad(false);
        }
        else if(response.err){
            alert('Incorrect Password');
            setLoad(false);
        }
    }

  return (
    <LoggedInUi>
        <div className='text-black font-bold w-full h-[20%] flex justify-center my-[0.5vmax] items-center text-[3vmax]'>DELETE ACCOUNT</div>
        <div className='w-full flex flex-col justify-center items-center'><Password value={password} setValue={setPassword} label='Enter Password' view='delete' />
        <button onClick={(e)=>{
            e.preventDefault();
            setLoad(true);
            deleteAccount();
        }} style={{backgroundColor: '#462054'}} className='p-[0.5vmax] rounded-[0.5vmax] text-[1.1vmax] font-semibold text-white my-[1vmax]' >Confirm Delete</button>
        </div>

    </LoggedInUi>
  )
}

export default Delete